/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_User_Api_Key_CopiedInputs */



/**
* | output |
* | --- |
* | "API key copied to clipboard" |
*
* @param {Profile_Security_User_Api_Key_CopiedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_user_api_key_copied = /** @type {((inputs?: Profile_Security_User_Api_Key_CopiedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_User_Api_Key_CopiedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("API-Schlüssel in Zwischenablage kopiert")
	return /** @type {LocalizedString} */ ("API key copied to clipboard")
});